define('core/models/BaseUser',[
    'backbone',

    'core/config',
], function (
    Backbone,

    config
) {
    'use strict';

    var BaseUser = Backbone.Model.extend({
        defaults: {
            about: null,
            avatar: {
                // NOTE: the avatar URLs may not be defined at declaration-time, and
                //       might be modified by the host application later
                cache: config.urls.avatar.generic,
                permalink: config.urls.avatar.generic,
            },
            connections: {},
            email: null,  // Should not be passed unless request is by moderator
            isAnonymous: true,  // Anonymous by default
            isFollowedBy: null,
            isFollowing: null,
            joinedAt: null,  // Date time in string. Format: YYYY-MM-DDTHH:mm:ss
            name: null,
            profileUrl: null,
            url: null,
            username: null,

            numPosts: null,
            numFollowing: null,
            numForumsFollowing: null,
            numFollowers: null,
            numLikesReceived: null,

            // optional, attached parameters, passed on request-by-request basis
            isFlagged: null,
        },

        hasValidAvatar: function (attrs) {
            var avatar = attrs ? attrs.avatar : this.get('avatar');
            return avatar && avatar.cache;
        },

        isAnonymous: function () {
            return !this.get('id');
        },

        isRegistered: function () {
            return !this.isAnonymous();
        },

        validate: function (attrs) {
            if (!this.hasValidAvatar(attrs))
                return 'None of the avatar related properties can be null, undefined or empty on User models.';
        },

        toJSON: function () {
            var data = Backbone.Model.prototype.toJSON.apply(this, arguments);
            data.thread = {};

            // Validation does not have any effect if silent flag is set, like
            // in the first initialization so we fix the value on toJSON for
            // templates etc.
            if (!this.hasValidAvatar())
                data.avatar = this.defaults.avatar;

            // Tell us if this user is a user w/ a registered account.
            data.isRegistered = this.isRegistered();

            return data;
        },
    });

    return BaseUser;
});

